<template>
  <a
    class="nav-link p-2 btn d-flex align-items-center position-relative"
    :id="id"
    :href="link"
  >
    <i class="bi bi-bell-fill position-relative">
      <span
        v-if="unreadCount > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
      >
        {{ unreadCount }}
      </span>
    </i>
  </a>
</template>

<script>
const cmdNewsQuantity = "news.quantity";

export default {
  name: "NewsBadge",
  props: {
    id: {
      type: String,
      default: "news",
    },
    link: {
      type: String,
      default: "#/news",
    },
  },

  data() {
    return {
      unreadCount: 0,
    };
  },

  mounted() {
    let that = this;

    // Add reader
    this.reader = this.teoweb.addReader(function (gw, data) {
      // Check error
      if (gw.err) {
        that.error = "Error: " + gw.err;
        return;
      }
      that.error = "";

      // Process answer
      switch (gw.command) {
        // Process answer to cmdNewsQuantity command
        case cmdNewsQuantity: {
          that.unreadCount = data;
          break;
        }
      }
    });

    // Send cmdNewsQuantity command to WebRTC server when connected or
    // reconnected and than login
    this.check = this.whenConnectedLogin(() => {
      this.teoweb.sendCmd(cmdNewsQuantity);
    });
  },

  unmounted() {
    this.teoweb.delReader(this.reader);
    this.check.stop();
  },
};
</script>

<style scoped>
.badge {
  font-size: 0.6rem;
}
</style>
